import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Thai National ID generator following Single Responsibility Principle
 */
export class ThGenerator extends BaseGenerator {
  generate() {
    // Generate first 12 digits
    const digits = this.randomDigits(12);
    
    // Calculate check digit
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(digits[i]) * (13 - i);
    }

    const checkDigit = (11 - (sum % 11)) % 10;
    return digits + checkDigit;
  }
}